<template>
    <div class="calculation-summary">
        <div class="calculation-summary__row">
            <div class="label">
                {{ $t(label) | capitalize }}
            </div>
            <div class="value">
                {{ amountAfterTax | twoDecimals(false) }}
                <span class="currency">{{ $t('currencyAbbreviation') }}</span>
            </div>
        </div>
        <div class="calculation-summary__row">
            <div class="label">
                {{ $t('tax') | capitalize }}
            </div>
            <div class="value">
                {{ tax | twoDecimals(false) }}
                <span class="currency">{{ $t('currencyAbbreviation') }}</span>
            </div>
        </div>
    </div>
</template>

<script>
    import MathUtils from '@core/utils/math/MathUtils';
    import Vue from 'vue';

    export default Vue.component('TaxLimitsSummary', {
        props: {
            amount: {
                type: Number,
                required: false,
                default: 0,
            },
            taxLimits: {
                type: String,
                required: true,
            },
            minTaxableAmount: {
                type: Number,
                default: 0,
            },
            label: {
                type: String,
                required: true,
            },
            shouldRoundTax: {
                type: Boolean,
                default: false,
            }
        },
        computed: {
            amountAfterTax() {
                const amount = parseFloat(this.amount);

                if (!MathUtils.isNumber(amount)) {
                    return 0;
                }
                return amount - this.tax;
            },
            tax() {
                const amount = parseFloat(this.amount);
                let taxAmount = 0;

                if (!amount || !MathUtils.isNumber(amount)) {
                    return 0;
                }
                if (amount < this.minTaxableAmount) {
                    return 0;
                }
                const params = this.taxLimits.split('|');

                for (let i = 0; i < params.length; i += 4) {
                    const [
                        minAmount,
                        maxAmount,
                        additionalTax,
                        additionalTaxPercent
                    ] = params
                        .slice(i, i + 4)
                        .map(parseFloat);

                    if (minAmount < amount && (amount <= maxAmount || maxAmount === 0)) {
                        taxAmount = additionalTax + ((amount - minAmount) * additionalTaxPercent);
                        if (this.shouldRoundTax) {
                            return Math.round(taxAmount);
                        }
                        return taxAmount;
                    }
                }

                throw new Error('Amount does not have a config pair!');
            }
        },
    });
</script>



// WEBPACK FOOTER //
// src/app/modules/shared/components/TaxLimitsSummary.vue